import { getNotificationListViewRoute } from "@slfinrtl/ui-bff-routes"
import type { NotificationListItem, NotificationListItemStatus, NotificationListView } from "@slfinrtl/ui-bff-routes"
import { useBffDynamic } from "src/hooks"

export const defaultNotificationCenterFilterValues: NotificationCenterFilterValues = { statuses: ["OPEN", "SEEN"] }
export const onlyReadNotificationCenterFilterValues: NotificationCenterFilterValues = { statuses: ["READ"] }

export interface NotificationCenterFilterValues {
	notificationGroup?: NotificationListItem["group"]
	statuses: NotificationListItemStatus[]
}

export const useNotificationListView = () => {
	const fetchNotificationListView = useBffDynamic(getNotificationListViewRoute, "inline")

	return ([_, { notificationGroup, statuses }]: [
		string,
		NotificationCenterFilterValues,
	]): Promise<NotificationListView> => {
		return fetchNotificationListView({
			body: undefined,
			pathParams: {},
			queryParams: { notificationGroup, statuses },
		})
	}
}
